module.exports = __webpack_public_path__ + "static/media/Hire Skilled Workforce in Single Platform.d193b8d7.png";